var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPickup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#DD2736"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0307 6.97749C12.265 6.74318 12.6449 6.74318 12.8792 6.97749L15.1312 9.22948C15.2438 9.342 15.307 9.49461 15.307 9.65374C15.307 9.81287 15.2438 9.96548 15.1312 10.078L12.8792 12.33C12.6449 12.5643 12.265 12.5643 12.0307 12.33C11.7964 12.0957 11.7964 11.7158 12.0307 11.4815L13.8584 9.65374L12.0307 7.82602C11.7964 7.59171 11.7964 7.21181 12.0307 6.97749Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70215 9.65371C8.70215 9.32234 8.97078 9.05371 9.30215 9.05371H14.7069C15.0383 9.05371 15.3069 9.32234 15.3069 9.65371C15.3069 9.98508 15.0383 10.2537 14.7069 10.2537H9.30215C8.97078 10.2537 8.70215 9.98508 8.70215 9.65371Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6 5C6.93137 5 7.2 5.26863 7.2 5.6V13.7071C7.2 14.0385 6.93137 14.3071 6.6 14.3071C6.26863 14.3071 6 14.0385 6 13.7071V5.6C6 5.26863 6.26863 5 6.6 5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickup);
export default __webpack_public_path__ + "static/media/pickup.7a823eaae050b7de3e5056a67e1d1c7f.svg";
export { ForwardRef as ReactComponent };